// extracted by mini-css-extract-plugin
export default {"modalOverlay":"EditModal_modalOverlay__IKAtf","modal":"EditModal_modal__QxSqa","closeButton":"EditModal_closeButton__3zAVt"};